/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    STANDARD_CURRENCY: 'standardCurrency',
    CREDIT: 'credit',
    PASS: 'pass',
    BENEFIT: 'benefit',
    OTHER: 'other',
};
